








import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class BasePriceRow extends Vue {
  @Prop({ required: true })
  readonly label: string

  @Prop({ required: true })
  readonly priceWithTax: string

  get priceWithTaxNonEmptyString(): string {
    if (this.priceWithTax === '') {
      return '￥0'
    }

    return this.priceWithTax
  }
}
